<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-6 col-centered create-report-card">
                <div class="card p-4">
                    <div class="col-centered text-center">
                        <div class="custom-title pt-7">
                            Create a Screen Capture Report
                        </div>
                        <div class="custom-subheading pt-3">
                            We will analyze it, pull all the right information and you will
                            have access the report in your email.
                        </div>
                        <img alt="icon" class="pt-9" src="/media/misc/devices-pana.png" width="170"/>
                    </div>
                    <div class="form-body">
                        <div class="url-container">
                            <div class="url-link-icon-area">
                                <img alt="icon" src="/media/misc/link_hyperlink.png" width="20"/>
                            </div>
                            <input @input="setPageUrl" class="url-input-wrapper"
                                   placeholder="Enter the web page URL here"
                                   v-model.trim="swap.pageUrl"/>
                            <div class="error" v-if="!$v.swap.pageUrl.required">Field is required</div>
                            <div class="error" v-if="!$v.swap.pageUrl.url">Url not valid</div>
                        </div>
                        <div class="create-selector-container mt-10">
                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="selector-wrapper">
                                            <span class="switch switch-icon">
                                                <label>
                                                    <input type="checkbox" v-model="utils.isDeactivateJsActive"
                                                           value="deactivate_js"/>
                                                    <span></span>
                                                </label>
                                            </span>
                                            <label class="selector-label">
                                                Deactivate Javascript
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="selector-wrapper">
                                            <span class="switch switch-icon">
                                                <label>
                                                    <input type="checkbox" v-model="utils.isFullpageActive"
                                                           value="fullpage"/>
                                                    <span></span>
                                                </label>
                                            </span>
                                            <label class="selector-label">
                                                Full Page capture
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--list of blockchains-->
                        <app-list-of-blockchains />

                        <div class="text-center pt-10">
                            <button :class="{'disabled': !utils.isPageUrlValid}"
                                    @click="createReport"
                                    class="btn btn-success font-weight-bold custom-btn-create-report px-6 py-3"
                                    href="#">
                                Create Report
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

   import {bus} from '../../main';
   import {validationMixin} from 'vuelidate';
   import {required, url} from 'vuelidate/lib/validators';
   import ListOfBlockchains from '../content/custom/ListOfBlockchains';
   import {CHANGE_COMPONENT, SAVE_REPORT_FIELDS} from '../../core/store/modules/report';

   export default {
      name: "ReportCreate",
      data() {
         return {
            utils: {
               isPageUrlValid: false,
               isFullpageActive: false,
               isDeactivateJsActive: false,
            },
            swap: {
               pageUrl: '',
               selectedBlockchain: 'None',
            }
         };
      },
      validations: {
         swap: {
            pageUrl: {
               url,
               required,
            }
         },
      },
      mixins: [validationMixin],
      components: {
         appListOfBlockchains: ListOfBlockchains
      },
      methods: {
         setPageUrl(event) {
            let pattern = /^((http|https):\/\/)/;
            this.swap.pageUrl = !pattern.test(event.target.value) ? `http://${event.target.value}` : event.target.value;
            this.$v.swap.pageUrl.$touch();
            this.utils.isPageUrlValid = (this.$v.swap.pageUrl.url && this.$v.swap.pageUrl.required);
         },
         createReport() {
            if (!this.utils.isPageUrlValid) {
               console.log('sorry! you can\'t');
               return;
            }

            const fields = {
               type: 'SCREENPROOF',
               source: this.swap.pageUrl,
               source_id: '---',
               sign_font: '---',
               sign_name: '---',
               sign_sign: '---',
               fullpage: this.utils.isFullpageActive,
               blockchain: this.swap.selectedBlockchain,
               activate_js: this.utils.isDeactivateJsActive,
            };

            this.$store.dispatch(SAVE_REPORT_FIELDS, fields);

            this.$store.dispatch(CHANGE_COMPONENT, 'appReportCompiling');
         }
      },
      mounted() {
         bus.$on('emit_selected_blockchain', (bc) => {
            this.swap.selectedBlockchain = bc;
         });
      }
   }
</script>


<style scoped>
    .error {
        color: red;
        font-size: 10px;
    }

    .disabled {
        cursor: not-allowed;
        pointer-events: none;
    }
</style>